<div class="container-billers">
  <h1 class="header-title"> 
    <span class="back" (click)="onBack()">
      <flame-icon svgIcon="chevron-left" />
    </span>  
    Compañía telefonica
  </h1>
    <ul class="list-billers">
      <li class="card -list" *ngFor="let item of billers" (click)="onSelected(item)">
        <app-basic-card type="navigation" [picture]="getPicture(item)">
          <p class="card__select">{{ item.name }}</p>
        </app-basic-card>
      </li>
    </ul>
  </div>
